export class OverheadCategory {
    id?: string;
    categoryName: string;
    excludeFromFinances: boolean;
    hidden: boolean;

    constructor(categoryName: string, excludeFromFinances?: boolean, hidden?: boolean) {
        this.categoryName = categoryName;
        this.excludeFromFinances = excludeFromFinances !== undefined ? excludeFromFinances : false;
        this.hidden = hidden !== undefined ? hidden : false;
    }
}
